import { degrees, PDFDocument } from 'pdf-lib';

export const rotatePdfAllPagesClockwise90 = async (file: File): Promise<File> => {
  const bytes = await file.arrayBuffer();
  const pdfDoc = await PDFDocument.load(bytes);

  for (const page of pdfDoc.getPages()) {
    const currentAngle = page.getRotation().angle;
    page.setRotation(degrees((currentAngle + 90) % 360));
  }

  const saved = await pdfDoc.save();
  return new File([saved], file.name, { type: 'application/pdf' });
};
